import { useLocation } from "react-router-dom";
import { UtilService } from "../../../Shared/Utils/UtilService";
import { GenericImage } from "../../../Shared/components/GenericImage";
import { GenericZoomFile } from "../../../Shared/components/GenericZoomFile";

export const PostDetail = () => {
  const location = useLocation();
  const post = location.state?.post;

  return (
    <>
      <div className="max-w-screen-xl px-4 py-8x mx-auto py-4">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-4">
          {post?.name}
        </h1>

        <div className="flex items-center text-sm text-gray-600 mb-6">
          {post?.user && (
            <span className="text-lg mr-4">
              <span className="font-bold">Author:</span>{" "}
              {UtilService.titleCase(post?.user?.firstName)}{" "}
              {UtilService.titleCase(post?.user?.lastName)}
            </span>
          )}
          {post?.company && (
            <span className="text-lg">
              <span className="font-bold">Company:</span>{" "}
              {UtilService.titleCase(post?.company?.name)}
            </span>
          )}
        </div>

        <GenericImage
          src={UtilService.base64ToAttachment(post?.cover, post?.extension)}
          className="w-full h-80 object-cover rounded-lg shadow-md mb-8"
        />

        <div className="prose prose-lg text-gray-800 mb-8 pt-4">
          <p>{post?.description}</p>
        </div>

        {post?.post && (
          <div className="mb-8 p-4 bg-gray-50 rounded-lg border border-gray-200">
            <h3 className="text-lg font-semibold text-gray-700 mb-2">
              Parent Post
            </h3>
            <p className="text-gray-600">
              <span className="font-medium">{post?.post?.name}</span>
            </p>
          </div>
        )}

        {post?.posts && post?.posts?.length > 0 && (
          <div className="mb-8 p-4">
            <h3 className="text-lg  text-gray-700 mb-2">Replies</h3>
            <ul className="list-disc pl-5 text-gray-600">
              {post.posts.map((childPost: any) => (
                <li key={childPost?.id}>{childPost?.name}</li>
              ))}
            </ul>
          </div>
        )}

        {post?.attachments && post?.attachments?.length > 0 && (
          <div className="py-4">
            <h3 className="text-lg font-semibold text-gray-700 mb-2">
              Attachments
            </h3>
            <div className="grid flex row grid-cols-5 gap-4">
              {post.attachments.map((attachment: any) => (
                <div key={attachment?.id} className="mb-4">
                  <GenericZoomFile src={attachment} height={200} width={200} />
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="text-left text-md text-gray-700 my-8 pt-4 border-t border-gray-100">
          <p>Created: {UtilService.toLocalDate(post?.createdAt)}</p>
          <p>Last Updated: {UtilService.toLocalDate(post?.updatedAt)}</p>
        </div>
      </div>
    </>
  );
};
